
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-icon',
    template: `<mat-icon *ngIf='props.icon'>{{field.formControl?.value}}</mat-icon>
  <span>{{props.label}}</span>
  <mat-hint *ngIf='!props.description'>{{props.description}}</mat-hint>`,
    styleUrls: ['../../../assets/global-settings.scss'],
    standalone: false
})
export class IconComponent extends FieldType {
}
